import React from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import {
  selectPackingGateRows,
  selectPackingGates,
} from '../../../../features/operatorPacking/operatorPackingUtils';

/**
 * What the order still needs before it closes: a checklist with ✓ or ✗ and
 * words, never colour alone, each failing row saying what is missing. The
 * gates are the server's, or worked out from the lines and items.
 */
export const PackingGates = () => {
  const gates = useSelector(selectPackingGates);
  const rows = useSelector(selectPackingGateRows);
  if (!gates) return null;

  return (
    <section
      data-testid="packing-gates"
      data-ready={String(Boolean(gates.ready))}
      aria-labelledby="packing-gates-title"
      className="space-y-3 rounded-3xl border border-border bg-white p-4 dark:bg-[#1a1a1a]"
    >
      <h2 id="packing-gates-title" className="text-sm font-bold text-ninja-dark dark:text-white">
        Para cerrar la orden
      </h2>
      <ul className="space-y-3">
        {rows.map((row) => (
          <li
            key={row.gate}
            data-testid="packing-gate"
            data-gate={row.gate}
            data-ok={String(row.ok)}
            className="flex items-start gap-3"
          >
            <span
              aria-hidden="true"
              className={clsx(
                'flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-bold',
                row.ok ? 'bg-ninja-green text-white' : 'bg-ninja-gray text-ninja-dark dark:bg-[#2d2d2d] dark:text-white'
              )}
            >
              {row.ok ? '✓' : '✗'}
            </span>
            <div className="min-w-0">
              <p className="text-base font-semibold text-ninja-dark dark:text-white">
                <span className="sr-only">{row.ok ? 'Listo: ' : 'Falta: '}</span>
                {row.label}
              </p>
              {row.missing && <p className="text-sm text-text-secondary">{row.missing}</p>}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};
